import { tv as e } from "tailwind-variants";
import { jsx as t } from "react/jsx-runtime";
//#region src/components/Heading/Heading.tsx
var n = e({
	base: "text-ic-heading font-ic-heading font-bold",
	variants: { variant: {
		h1: "text-xl md:text-2xl xl:text-3xl",
		h2: "text-lg md:text-xl xl:text-2xl",
		h3: "text-base xl:text-lg",
		h4: "text-sm xl:text-base"
	} },
	defaultVariants: { variant: "h2" }
});
function r({ as: e, className: r, variant: i, ...a }) {
	return /* @__PURE__ */ t(e ?? "h1", {
		...a,
		className: n({
			variant: i,
			className: r
		})
	});
}
//#endregion
export { r as Heading, n as headingVariants };
